import { render } from "./AppAlert.vue?vue&type=template&id=2935a3c1&scoped=true"
import script from "./AppAlert.vue?vue&type=script&lang=js"
export * from "./AppAlert.vue?vue&type=script&lang=js"

import "./AppAlert.vue?vue&type=style&index=0&id=2935a3c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2935a3c1"]])

export default __exports__